export default __webpack_public_path__ + "static/media/bd-sim-large.1c349889.jpg";